<template>
  <div class="p-app-search-shortcuts flex flex-wrap line-height-6">
    <CShortcut>
      <CShortcutIcon icon="arrow-up" />
      {{ t('canvasUI.CGlobalSearch.shortcuts.or') }}

      <CShortcutIcon icon="arrow-down" />
      {{ t('canvasUI.CGlobalSearch.shortcuts.navigate') }}
    </CShortcut>

    <CShortcut>
      <CShortcutIcon icon="arrow-turn-down-left" />
      {{ t('canvasUI.CGlobalSearch.shortcuts.open') }}
    </CShortcut>

    <CShortcut>
      <CShortcutIcon icon="slash-forward" />
      {{ t('canvasUI.CGlobalSearch.shortcuts.find') }}
    </CShortcut>

    <CShortcut>
      <CShortcutIcon :text="t('canvasUI.CGlobalSearch.shortcuts.esc')" />
      {{ t('canvasUI.CGlobalSearch.shortcuts.exit') }}
    </CShortcut>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CShortcut from '@lib/components/CShortcut/CShortcut.vue'
import CShortcutIcon from '@lib/components/CShortcut/CShortcutIcon.vue'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.p-app-search-shortcuts {
  gap: 16px 32px;
}
</style>
